import {IProductStoreEventContext} from 'modules/analytics/types/ProductSnippetAnalytics';

interface IProductAvailabilityFields {
    canBuy: boolean;
    canReserve: boolean;
    storesWithStock?: string[];
}

// Признак и число винотек с наличием — источник для buildProductStoreEventContext,
// см. «Разметка. PLP. Сниппет».
export const getStoreEventContext = (product: IProductAvailabilityFields): IProductStoreEventContext => ({
    isOnlyInStores: !product.canBuy && product.canReserve,
    storesWithStockCount: product.storesWithStock?.length || 0,
});
